/**
 * Loose diamonds education guide: TOC scroll-spy and mobile jump control.
 */
(function () {
  const root = document.querySelector('[data-loose-diamonds-guide]');
  if (!root) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  root.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#ld-"]');
    if (!a || !root.contains(a)) return;
    const id = a.getAttribute('href')?.slice(1);
    const el = id ? document.getElementById(id) : null;
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) {
      history.replaceState(null, '', '#' + id);
    }
  });

  if (!('IntersectionObserver' in window)) return;

  const sections = root.querySelectorAll('[data-guide-section]');
  const tocLinks = root.querySelectorAll('[data-guide-toc-link]');
  const mobileJump = root.querySelector('[data-guide-mobile-jump]');

  if (sections.length === 0 || tocLinks.length === 0) return;

  const byId = new Map();
  tocLinks.forEach((link) => {
    const id = link.getAttribute('href')?.replace('#', '');
    if (id) byId.set(id, link);
  });

  function setActive(id) {
    tocLinks.forEach((link) => {
      const lid = link.getAttribute('href')?.replace('#', '');
      const isActive = lid === id;
      link.setAttribute('aria-current', isActive ? 'true' : 'false');
      link.classList.toggle('is-active', isActive);
    });
    if (mobileJump && id) {
      mobileJump.value = id;
    }
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const id = entry.target.id;
        if (id) setActive(id);
      });
    },
    {
      rootMargin: '-20% 0px -55% 0px',
      threshold: 0,
    }
  );

  sections.forEach((section) => observer.observe(section));

  if (mobileJump) {
    mobileJump.addEventListener('change', () => {
      const id = mobileJump.value;
      if (!id) return;
      const el = document.getElementById(id);
      if (el)
        el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  tocLinks.forEach((link) => {
    link.addEventListener('click', () => {
      const id = link.getAttribute('href')?.replace('#', '');
      if (id) setTimeout(() => setActive(id), 400);
    });
  });

  const hash = window.location.hash?.replace('#', '');
  if (hash && byId.has(hash)) {
    setActive(hash);
  } else if (sections[0]?.id) {
    setActive(sections[0].id);
  }
})();
